import { useRef, useState } from 'react';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from '@mui/material';
import { toast } from 'react-toastify';

// Generic name prompt used for "Als Template speichern" and for saving
// elements to "Meine Elemente". onConfirm receives the name and is awaited.
const NameDialog = ({ open, title, label, description, defaultValue, confirmLabel = 'Speichern', onClose, onConfirm }) => {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const handleConfirm = async () => {
    const name = (inputRef.current?.value || '').trim();
    if (!name) {
      toast.error('Bitte einen Namen eingeben.');
      return;
    }
    setBusy(true);
    try {
      await onConfirm(name);
      onClose();
    } catch (error) {
      // Error toast is shown by the caller; keep the dialog open for a retry.
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onClose={busy ? undefined : onClose} maxWidth='xs' fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {description && <DialogContentText>{description}</DialogContentText>}
        <TextField
          label={label}
          size='small'
          fullWidth
          autoFocus
          inputRef={inputRef}
          defaultValue={defaultValue || ''}
          onKeyDown={event => {
            if (event.key === 'Enter') handleConfirm();
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={busy}>
          Abbrechen
        </Button>
        <Button
          variant='contained'
          onClick={handleConfirm}
          disabled={busy}
          startIcon={busy ? <CircularProgress size={16} /> : null}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NameDialog;
